module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-7-f60da59c47406eb38620f28be0ffb075.png";